/**
 * @generated SignedSource<<2fc8b1813a0315db516bf778654fb48f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type useDisablePropertyMutation$variables = {
  now: string;
  property_id: number;
};
export type useDisablePropertyMutation$data = {
  readonly update_sys_properties: {
    readonly affected_rows: number;
  } | null;
  readonly update_sys_properties_batch_validation_rules: {
    readonly affected_rows: number;
  } | null;
  readonly update_sys_properties_dataset_validation_rules: {
    readonly affected_rows: number;
  } | null;
  readonly update_sys_properties_datasets: {
    readonly affected_rows: number;
  } | null;
  readonly update_sys_properties_mapping_sets: {
    readonly affected_rows: number;
  } | null;
  readonly update_sys_properties_roles_users: {
    readonly affected_rows: number;
  } | null;
  readonly update_sys_property_relationships: {
    readonly affected_rows: number;
  } | null;
  readonly update_sys_providers_properties: {
    readonly affected_rows: number;
  } | null;
};
export type useDisablePropertyMutation = {
  response: useDisablePropertyMutation$data;
  variables: useDisablePropertyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "now"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "property_id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "_eq",
    "variableName": "property_id"
  }
],
v3 = {
  "fields": (v2/*: any*/),
  "kind": "ObjectValue",
  "name": "property_id"
},
v4 = [
  {
    "kind": "Literal",
    "name": "_set",
    "value": {
      "is_active": false
    }
  },
  {
    "fields": [
      (v3/*: any*/)
    ],
    "kind": "ObjectValue",
    "name": "where"
  }
],
v5 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "affected_rows",
    "storageKey": null
  }
],
v6 = {
  "fields": [
    {
      "kind": "Variable",
      "name": "inactivated_at_datetime",
      "variableName": "now"
    }
  ],
  "kind": "ObjectValue",
  "name": "_set"
},
v7 = {
  "kind": "Literal",
  "name": "is_active",
  "value": {
    "_eq": true
  }
},
v8 = [
  {
    "alias": null,
    "args": (v4/*: any*/),
    "concreteType": "sys_properties_roles_users_mutation_response",
    "kind": "LinkedField",
    "name": "update_sys_properties_roles_users",
    "plural": false,
    "selections": (v5/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": (v4/*: any*/),
    "concreteType": "sys_properties_mapping_sets_mutation_response",
    "kind": "LinkedField",
    "name": "update_sys_properties_mapping_sets",
    "plural": false,
    "selections": (v5/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": (v4/*: any*/),
    "concreteType": "sys_properties_datasets_mutation_response",
    "kind": "LinkedField",
    "name": "update_sys_properties_datasets",
    "plural": false,
    "selections": (v5/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": (v4/*: any*/),
    "concreteType": "sys_properties_batch_validation_rules_mutation_response",
    "kind": "LinkedField",
    "name": "update_sys_properties_batch_validation_rules",
    "plural": false,
    "selections": (v5/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": (v4/*: any*/),
    "concreteType": "sys_properties_dataset_validation_rules_mutation_response",
    "kind": "LinkedField",
    "name": "update_sys_properties_dataset_validation_rules",
    "plural": false,
    "selections": (v5/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": (v4/*: any*/),
    "concreteType": "sys_properties_mutation_response",
    "kind": "LinkedField",
    "name": "update_sys_properties",
    "plural": false,
    "selections": (v5/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      (v6/*: any*/),
      {
        "fields": [
          (v7/*: any*/),
          (v3/*: any*/)
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "sys_providers_properties_mutation_response",
    "kind": "LinkedField",
    "name": "update_sys_providers_properties",
    "plural": false,
    "selections": (v5/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      (v6/*: any*/),
      {
        "fields": [
          (v7/*: any*/),
          {
            "fields": (v2/*: any*/),
            "kind": "ObjectValue",
            "name": "property_id_from"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "sys_property_relationships_mutation_response",
    "kind": "LinkedField",
    "name": "update_sys_property_relationships",
    "plural": false,
    "selections": (v5/*: any*/),
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useDisablePropertyMutation",
    "selections": (v8/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useDisablePropertyMutation",
    "selections": (v8/*: any*/)
  },
  "params": {
    "cacheID": "8d044b239689b68d00f78d6585486c4b",
    "id": null,
    "metadata": {},
    "name": "useDisablePropertyMutation",
    "operationKind": "mutation",
    "text": "mutation useDisablePropertyMutation(\n  $property_id: Int!\n  $now: timestamptz!\n) {\n  update_sys_properties_roles_users(_set: {is_active: false}, where: {property_id: {_eq: $property_id}}) {\n    affected_rows\n  }\n  update_sys_properties_mapping_sets(_set: {is_active: false}, where: {property_id: {_eq: $property_id}}) {\n    affected_rows\n  }\n  update_sys_properties_datasets(_set: {is_active: false}, where: {property_id: {_eq: $property_id}}) {\n    affected_rows\n  }\n  update_sys_properties_batch_validation_rules(_set: {is_active: false}, where: {property_id: {_eq: $property_id}}) {\n    affected_rows\n  }\n  update_sys_properties_dataset_validation_rules(_set: {is_active: false}, where: {property_id: {_eq: $property_id}}) {\n    affected_rows\n  }\n  update_sys_properties(_set: {is_active: false}, where: {property_id: {_eq: $property_id}}) {\n    affected_rows\n  }\n  update_sys_providers_properties(_set: {inactivated_at_datetime: $now}, where: {property_id: {_eq: $property_id}, is_active: {_eq: true}}) {\n    affected_rows\n  }\n  update_sys_property_relationships(_set: {inactivated_at_datetime: $now}, where: {is_active: {_eq: true}, property_id_from: {_eq: $property_id}}) {\n    affected_rows\n  }\n}\n"
  }
};
})();

(node as any).hash = "8404126d4b7165da0488b6cf7dd2f8d5";

export default node;
